import React, { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Brain, Gauge, Loader2, Zap } from 'lucide-react';
import { klarysUrl } from './klarysApi';

const CHOIX = [
  ['rapide', 'Rapide', 'Claude Haiku', 'Réponses les plus rapides, idéal pour les recherches simples.', Zap],
  ['equilibre', 'Équilibré', 'Claude Sonnet', 'Bon compromis rapidité / précision (réglage par défaut).', Gauge],
  ['precis', 'Précis', 'Claude Opus', 'Raisonnement le plus poussé ; plus lent et plus coûteux en crédits.', Brain],
];

export const KlarysModeleIA = ({ p, setP, headers, superAdmin }) => {
  const [busy, setBusy] = useState(null);
  const choisir = async (k) => {
    if (!superAdmin || k === p.modele) return;
    setBusy(k);
    try { const r = await axios.put(klarysUrl('/parametres'), { modele: k }, { headers }); setP((prev) => ({ ...prev, modele: r.data.modele })); toast.success(`Klarys utilise désormais le mode « ${CHOIX.find((c) => c[0] === k)[1]} »`); }
    catch (e) { toast.error(e.response?.data?.detail || 'Changement impossible'); } finally { setBusy(null); }
  };
  return (
    <section className="space-y-2 rounded-xl border border-slate-200 bg-white p-3" data-testid="klarys-modele-ia">
      <h4 className="text-sm font-semibold text-slate-900">Modèle IA de Klarys <span className="font-normal text-slate-500">— s'applique à tous les utilisateurs</span></h4>
      <div className="grid gap-2 sm:grid-cols-3">
        {CHOIX.map(([k, label, modele, desc, Icon]) => {
          const actif = (p.modele || 'equilibre') === k;
          return (
            <button key={k} type="button" disabled={!superAdmin || !!busy} onClick={() => choisir(k)} data-testid={`klarys-modele-${k}`} aria-pressed={actif}
              className={`rounded-lg border p-2.5 text-left transition-colors ${actif ? 'border-[#0a3d62] bg-sky-50 ring-1 ring-[#0a3d62]' : 'border-slate-200 hover:border-slate-400'} disabled:cursor-default`}>
              <p className="flex items-center gap-1.5 text-sm font-semibold text-slate-900">
                {busy === k ? <Loader2 className="h-4 w-4 animate-spin" /> : <Icon className="h-4 w-4 text-[#0a3d62]" />} {label}
                {actif && <span className="ml-auto rounded-full bg-[#0a3d62] px-1.5 text-[10px] text-white" data-testid={`klarys-modele-actif-${k}`}>actif</span>}
              </p>
              <p className="text-[11px] text-slate-500">{modele}</p>
              <p className="mt-1 text-[11px] text-slate-600">{desc}</p>
            </button>
          );
        })}
      </div>
      {!superAdmin && <p className="text-[11px] text-slate-500">Seul le super administrateur peut changer le modèle.</p>}
    </section>
  );
};
